import { Select } from "antd";
import { useMemo } from "react";

const ReferenceSelector = ({ referenceGetId, referenceDisplayString, referenceList, ...rest }: any) => {

  const { data: referenceListItemsData } = referenceList();
  const referenceListItems = referenceListItemsData?.items;
  const options = useMemo(() => referenceListItems?.map(e => ({ value: referenceGetId(e), label: referenceDisplayString(e) })), [referenceListItems, referenceDisplayString, referenceGetId])  

  return (
    <Select
          {...rest}
          placeholder="Search to Select"
          optionFilterProp="label"
          filterSort={(optionA, optionB) =>
            `${(optionA?.label ?? '')}`.toLowerCase().localeCompare(`${(optionB?.label ?? '')}`.toLowerCase())
          }
          options={options}
        />
  )
}

export default ReferenceSelector;